import {
  LOAD_ASSET_TYPES,
  LOAD_ASSET_TYPES_SUCCESS,
  LOAD_ASSET_TYPES_ERROR,
} from "../Types/assetTypes.constants";

// import axios from "axios";
import axios from "../../Utils/AxiosConfig/axiosConfig";
import { put, call, takeEvery } from "redux-saga/effects";

//function to get all assetTypes from the api
const getAssetTypes = async () => {
  let assetTypes: any = [];
  let res = null,
    page = 1;
  //loop to fetch all pages from api
  do {
    res = await axios.get(`assetTypes?pageSize=100&page=${page++}`);
    assetTypes = assetTypes.concat(res.data.rows);
  } while (res.data.page < res.data.totalPages);
  return assetTypes;
};

export function* listAssetTypes(): any {
  try {
    const data = yield call(() =>
      getAssetTypes().then((res) => {
        return res;
      })
    );
    yield put({
      type: LOAD_ASSET_TYPES_SUCCESS,
      payload: data,
    });
  } catch (error: any) {
    console.error(error.response);
    yield put({
      type: LOAD_ASSET_TYPES_ERROR,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
}

export function* listAssetTypesSaga() {
  yield takeEvery(LOAD_ASSET_TYPES, listAssetTypes);
}
